export interface AbaDeConfiguracao {
  readonly id: string;
  readonly rotulo: string;
  readonly conteudo: JSX.Element;
}

/**
 * A faixa de abas da Central de Configurações — a de cima (Serviços,
 * Automações) e a de cada serviço.
 *
 * `role="group"` com `aria-pressed`, e não um widget de abas: abas exigem
 * `tabpanel` associado e navegação por seta, e a biblioteca de UI não tem abas
 * de propósito.
 *
 * As seções de um serviço só ganham a faixa quando são mais de uma: com uma,
 * o botão já viria marcado e não trocaria nada — e o próprio conteúdo tem
 * título ("Aviso de SISCRED", "Pipeline").
 */
export function BarraDeAbas(props: {
  readonly rotulo: string;
  readonly abas: readonly { readonly id: string; readonly rotulo: string }[];
  readonly atual: string;
  readonly aoTrocar: (id: string) => void;
}): JSX.Element {
  return (
    <div role="group" aria-label={props.rotulo} className="flex flex-wrap gap-2">
      {props.abas.map((a) => {
        const ativo = a.id === props.atual;
        return (
          <button
            key={a.id}
            type="button"
            aria-pressed={ativo}
            onClick={() => props.aoTrocar(a.id)}
            className={`inline-flex h-9 items-center rounded-card border px-4 text-sm transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-acento-ciano ${
              ativo
                ? 'border-acento-ciano/50 bg-acento-ciano/10 font-medium text-acento-ciano'
                : 'border-borda text-conteudo-secundario hover:text-conteudo-primario'
            }`}
          >
            {a.rotulo}
          </button>
        );
      })}
    </div>
  );
}
